// semeia-disable-reexport
import type {
  DmpConnectTlsiError,
  InsIdentityResult
} from "parog-web/cnam/types";

export class AbstractCnamApiError extends Error {
  declare name: string;

  constructor(
    message = "",
    public error: Error | undefined = undefined
  ) {
    super(message);
  }
}

export class CnamApiInsError extends AbstractCnamApiError {
  override name = "cnam-api-ins-error";

  constructor(
    message = "",
    public override error: DmpConnectTlsiError | undefined = undefined,
    public identity?: InsIdentityResult
  ) {
    super(message, error);
  }
}

export class CnamApiInsNoIdentityFoundError extends CnamApiInsError {
  override name = "cnam-api-ins-no-identity-found-error";
}

export class CnamApiInsMultipleIdentityFoundError extends CnamApiInsError {
  override name = "cnam-api-ins-multiple-identity-found-error";
}
export class CnamApiInsIdentityCorruptedError extends CnamApiInsError {
  override name = "cnam-api-ins-identity-corrupted-error";
}

export class CnamApiInsMandatoryInfoMissingError extends CnamApiInsError {
  override name = "cnam-api-ins-mandatory-info-missing-error";
}

export class CnamApiInsConflictWithSsnError extends CnamApiInsError {
  override name = "cnam-api-ins-conflict-with-ssn-error";
}

export class CnamApiInsNoSexError extends CnamApiInsError {
  override name = "cnam-api-ins-no-sex-error";
}

export class CnamApiInsBirthdayInvalidError extends CnamApiInsError {
  override name = "cnam-api-ins-birthday-invalid-error";
}

export class CnamApiInsPatientInvalid extends CnamApiInsError {
  override name = "cnam-api-ins-patient-invalid";
}

export class CnamApiCpsCardInfosMissing extends AbstractCnamApiError {
  override name = "cnam-api-cps-card-infos-missing";
}

// Error class for low level DmpConnectJS errors
export class CnamApiError extends AbstractCnamApiError {
  override name = "cnam-api-error";
}

export class CnamApiVitaleCardError extends AbstractCnamApiError {
  override name = "cnam-api-vitale-card-error";
}

export class CnamApiCpsCardError extends AbstractCnamApiError {
  override name = "cnam-api-cps-card-error";
}

export class CnamApiCpsNoBillingNumber extends CnamApiCpsCardError {
  override name = "cnam-api-cps-no-billing-number";
}

export class CnamApiCpsNoPracticeLocations extends CnamApiCpsCardError {
  override name = "cnam-api-cps-no-practice-locations";
}

export class CnamApiCpsCardWrongCode extends AbstractCnamApiError {
  override name = "cnam-api-cps-card-wrong-code";
}

export class CnamApiCpsCardBlocked extends AbstractCnamApiError {
  override name = "cnam-api-cps-card-blocked";
}

// If the medic is blacklisted from this DMP
export class CnamApiDmpAuthorizationDenied extends AbstractCnamApiError {
  override name = "cnam-api-dmp-authorization-denied";
}

// The DMP is closed and must be re-opened
export class CnamApiDmpStatusClosed extends AbstractCnamApiError {
  override name = "cnam-api-dmp-status-closed";
}

// The DMP has not been created yet
export class CnamApiDmpStatusNotFound extends AbstractCnamApiError {
  override name = "cnam-api-dmp-status-not-found";
}

// No reimbursement file found in the DMP
export class CnamApiDmpNoReimbursementDocument extends AbstractCnamApiError {
  override name = "cnam-api-dmp-no-reimbursement-document";
}

export class CnamApiDmpReimbursementDocumentFormatNotSupported extends AbstractCnamApiError {
  override name = "cnam-api-dmp-reimbursement-document-format-not-supported";
}

export class CnamApiDmpDocumentFailedToSave extends AbstractCnamApiError {
  override name = "cnam-api-dmp-document-failed-to-save";
}

export class CnamApiDmpParsingFileError extends AbstractCnamApiError {
  override name = "cnam-api-dmp-parsing-file-error";
}

export class CnamApiDmpConnectJSNotAvailable extends AbstractCnamApiError {
  override name = "cnam-api-dmpconnect-js-not-available";
}
